angular.module('olivioConfiguratorApp').factory('AdvancedLoginService', ['$http', 'env', 'Model', function ($http, env, Model) {
  //console.log('init AdvancedLoginService');
  // FIXME Lif kann sich beim Server abmelden, Olivio nicht. Problem: bei anmeldung mit falschen Credentials wird bestehender User zurückgeliefert
  // prüfen: ist das auch auf dem Server so?. dann muss das geändert werden: falls user mitgeliefert wird, darf hinterher kein anderer zurückgemeldet werden
  // TODO immer gleich den Server fragen, ob man bereits (via Cookie) angemeldet ist und dann diese info nutzen -> Trennung von Advanced-Mode und Login
    var testUsers = [
      {
        user: 'peter_maffay',
        password: 'tabaluga'
      },
      {
        user: 'maja',
        password: 'willi'
      },
      {
        user: 'r_whittaker',
        password: 'tanzheutnachtmitmir'
      }
    ];

    var login = {
      loginIsVisible: false,
      advancedToBasicWarningIsVisible: false,
      advancedLoginUser: "",
      advancedLoginPassword: ""
    };

    var hideAll=function() {
      login.advancedLoginUser = "";
      login.advancedLoginPassword = "";
      login.loginIsVisible = false;
      login.advancedToBasicWarningIsVisible = false;
    };

    login.authenticateTestUser = function (userName, password) {
      for (var i = 0; i < testUsers.length; i++) {
        if (testUsers[i].user === userName && login.Users[i].password === password) {
          return true;
        }
      }
    };

    login.authenticateUser = function (userName, password) {
      return $http.post(env.authUrl, {userName: userName, password: password});
    };

    login.toggle = function() {
      hideAll();
      if (Model.model.userOptions.advanced === false) {
        login.loginIsVisible = true;
        Model.resetUserOptions();
      } else if (Model.model.userOptions.advanced === true) {
        login.advancedToBasicWarningIsVisible = true;
      }
    };

    return login;
  }]);

angular.module('olivioConfiguratorApp')
  .controller('AdvancedLoginCtrl',
	['$rootScope', '$scope', 'Model', 'Data', 'AdvancedLoginService', 'OLIVIOMainFactory', 'StepService', 'ColorSelectService', 'Storage', '$window', '$location',
       function ($rootScope, $scope, Model, Data, AdvancedLoginService, OLIVIOMainFactory, StepService, ColorSelectService, Storage, $window, $location) {
    //console.log('init AdvancedLoginCtrl');

    $scope.OLIVIO = OLIVIO;
    $scope.model = Model.model;
    $scope.data = Data;
    $scope.service = AdvancedLoginService;


    // form data via ng-model
    $scope.configurationNumber = "";



    $scope.loginProceed = function () {
      if (AdvancedLoginService.authenticateTestUser(AdvancedLoginService.advancedLoginUser, AdvancedLoginService.advancedLoginPassword)) {
        activateAdvancedMode();
      } else {
        console.log('loginProceed', AdvancedLoginService.advancedLoginUser);
        AdvancedLoginService
          .authenticateUser(AdvancedLoginService.advancedLoginUser, AdvancedLoginService.advancedLoginPassword)
          .then(
            function(res) {
              var data = res.data;
              //var status = res.status;
              //var config = res.config;
              activateAdvancedMode(data);
              AdvancedLoginService.advancedLoginPassword = "";
            },
            onWrongLogin
          );
      }
    };

    $scope.loginCancel = function () {
      AdvancedLoginService.advancedToBasicWarningIsVisible = false;
      AdvancedLoginService.loginIsVisible = false;
      AdvancedLoginService.advancedLoginPassword = "";
    };

    $scope.loadConfiguration = function () {
      Storage.restoreConfigurationFromServer($scope.configurationNumber.replace("SX ", ""))
        .then(function () {
          $location.search('configurationNumber', null);
        }, Storage.restoreStateFromLocalStorage);
      StepService.updateEnabled();
      StepService.gotoStep("product");
    };

    $scope.warningProceed = function () {
      AdvancedLoginService.advancedToBasicWarningIsVisible = false;
      AdvancedLoginService.loginIsVisible = false;
      Model.model.userOptions.advanced = false;
      if(OLIVIOMainFactory.getCurrent())
        OLIVIOMainFactory.getCurrent().setEditAdvanced(Model.model.userOptions.advanced);
      //reset lums
      Model.resetAssembly();
      StepService.configurationSteps.filter(s => s.view === 'power')[0].skipped = false;
      StepService.updateEnabled();
    };

    $scope.warningCancel = function () {
      AdvancedLoginService.advancedToBasicWarningIsVisible = false;
      AdvancedLoginService.loginIsVisible = false;
    };

    function activateAdvancedMode(userData) {
      Model.model.userOptions.advanced = true;
      AdvancedLoginService.loginIsVisible = false;
      AdvancedLoginService.advancedToBasicWarningIsVisible = false; // FIXME das ist unnötig, oder auch bei der zweiten Warnung nötig

      // set user options
      /* jshint ignore:start */
      Model.model.userOptions.showArticleNumbers = (userData['olivio_show_article_number'] === true);
      Model.model.userOptions.showPrices = (userData['olivio_show_price'] === true);
      Model.model.userOptions.showDrillHoles = (userData['olivio_show_drillholes'] === true);
      /* jshint ignore:end */

      // set user display default options
      Model.model.userOptions.displayArticleNumbers = $scope.model.showArticleNumbers;
      Model.model.userOptions.displayPrices = $scope.model.showPrices;
      Model.model.userOptions.displayDrillHoles = $scope.model.showDrillHoles;

      if(OLIVIOMainFactory.getCurrent())
        OLIVIOMainFactory.getCurrent().setEditAdvanced($scope.model.userOptions.advanced);
    }

    function onWrongLogin() {
      $scope.model.userOptions.advanced = false;
      $('#loginshake').effect('shake');
    }
  }]);
